import { DetailsList, IconButton, PrimaryButton, SelectionMode } from "@fluentui/react";
import * as React from "react";
import { useContext, useEffect, useState } from "react";
import AppContent from "../Surfaces/AppContent";
import AuthContext from "../Services/AuthContext";
import { Link, useOutletContext } from "react-router-dom";
import AddAgreementCategory from "../Panel/AgreementCategory/AddAgreementCategory";
import EditAgreementCategory from "../Panel/AgreementCategory/EditAgreementCategory";

function AgreementCategory(props) {
    const [user] = useContext(AuthContext);
    const [categories, setCategories] = useState([]);
    const [refresh, setRefresh] = useState(0);
    useEffect(() => {
        const abortController = new AbortController();
        async function fetchData() {
            await fetch("/api/agreement_category", {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => { setCategories(data) })
                .catch(err => { console.log(err) })
        }
        fetchData();
        return () => abortController.abort();
    }, [refresh, user.token]);
    const [editCategory, setEditCategory] = useState(false);
    const [addCategory, setAddCategory] = useState(false);
    const actions = useOutletContext();
    useEffect(() => {
        actions([
            {
                key: 'addCategory',
                text: 'Dodaj Kategorię',
                iconProps: { iconName: 'Add' },
                onClick: () => setAddCategory(true)
            }
        ]);
        return actions;
    }, []);

    const columns = [
        {
            key: 'name',
            name: 'Nazwa',
            ariaLabel: 'Kategoria',
            fieldName: 'name',
            minWidth: 210,
            isRowHeader: true,
            isResizable: true,
            onRender: (item) => (<Link to={`/agreement_category/${item.id}`}><PrimaryButton text={`${item.name}`}/></Link>)
        },
        {
            key: 'type',
            name: 'Typ',
            ariaLabel: 'Typ',
            fieldName: 'type',
            minWidth: 210,
            isResizable: true,
        },
        {
            key: 'edit',
            name: 'Akcje',
            ariaLabel: 'Akcje',
            fieldName: 'edit',
            minWidth: 90,
            maxWidth: 90,
            onRender: (item) => (<span>
                <IconButton iconProps={ {iconName: 'edit' }} title='Edytuj' onClick={() => setEditCategory(item)}/>
                <IconButton iconProps={ {iconName: 'delete' }} title='Usuń' onClick={() => _deleteCategory(item)}/>
            </span>)
        }
    ];
    const _deleteCategory = (item) => {
        fetch(`/api/agreement_category/${item.id}`, {
            method: 'DELETE',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(json => { setRefresh(refresh + 1) })
            .catch(err => { console.log(err) })
    }

    return (
        <AppContent title={'Kategorie Umowy'}>
            <DetailsList items={categories} columns={columns} selectionMode={SelectionMode.none}/>
            <AddAgreementCategory add={addCategory} onSuccess={() => setRefresh(refresh + 1)} dismissPanel={() => setAddCategory(false)} />
            <EditAgreementCategory add={editCategory} onSuccess={() => setRefresh(refresh + 1)} dismissPanel={() => setEditCategory(false)} />
        </AppContent>
    );
}

export default AgreementCategory;